export default __webpack_public_path__ + "static/media/bannerHome.9ed68bb5.png";